export default {
  category_products: []
}
